export default __webpack_public_path__ + "static/media/a037-1.6277b75f.svg";